import React from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import CheckIcon from '@mui/icons-material/Check';
import ClearIcon from '@mui/icons-material/Clear';
import CircularProgress from '@mui/material/CircularProgress';
import StepConnector from '@mui/material/StepConnector';
import { styled } from '@mui/material/styles';

const CustomStepConnector = styled(StepConnector)(({ theme }) => ({   
    '& .MuiStepConnector-line': {
        borderColor: '#ceccccff',
    },
}));

const CustomStepIcon = ({ active, completed, status}) => {
    return (
        <div style={{ position: 'relative', width: 20, height: 20, zIndex: 1 }}>

            {status === "ERROR" ? 
            (<div
                    style={{
                        width: '100%',
                        height: '100%',
                        borderRadius: '50%',
                        backgroundColor: '#c53939ff',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        zIndex: 2,
                    }}
                >
                    <ClearIcon style={{ color: 'white', fontSize: 13 }} />
            </div>
            ) :  completed ? (
                <div
                    style={{
                        width: '100%',
                        height: '100%',
                        borderRadius: '50%',
                        backgroundColor: '#4caf50',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        zIndex: 2,
                    }}
                >
                    <CheckIcon style={{ color: 'white', fontSize: 13 }} />
                </div>
            ) : active ? (
                <div
                    style={{
                        width: '100%',
                        height: '100%',
                        borderRadius: '50%',
                        backgroundColor: '#e0e0e0',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        position: 'relative',
                        zIndex: 1,
                    }}
                >
                    <CircularProgress
                        size={13}
                        thickness={3}
                        style={{
                            color: '#4caf50',
                            position: 'absolute',
                        }}
                    />
                </div>
            ) : (
                <div
                    style={{
                        width: '100%',
                        height: '100%',
                        borderRadius: '50%',
                        backgroundColor: '#e0e0e0',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}
                />
            )}
        </div>
    );
};

CustomStepIcon.propTypes = {
    active: PropTypes.bool.isRequired,
    completed: PropTypes.bool.isRequired,
    status: PropTypes.string,
};



const StepperComponent = ({ stepsData }) => {

    const activeStep = Object.entries(stepsData).findIndex(([key, value]) => value === 'IN_PROGRESS')
    let isFailedStep = (index) => {

        return Object.values(stepsData)[index] === "ERROR"
    }

    return (
        <Box sx={{ justifyContent: 'center', width: '60%', alignItems: 'center' }}>
            {stepsData ?

            <Stepper
                activeStep={activeStep}
                alternativeLabel
                connector={<CustomStepConnector />}
                sx={{ margin: '20px 0 0 0' }}
            >
                    {Object.keys(stepsData).map((label, index) => {

                        const labelProps = {};
                        if (isFailedStep(index)) {
                            labelProps.error = true;
                        }

                        return (
                            <Step key={label}
                                    completed={Object.values(stepsData)[index] === "COMPLETED"}>
                                <StepLabel
                                    StepIconComponent={CustomStepIcon}
                                    sx={{ fontSize: '12px', '& .MuiStepLabel-label': { fontSize: '0.8rem' } }}
                                    {...labelProps}
                                    StepIconProps={{
                                        status: isFailedStep(index) ? "ERROR" : null
                                    }}
                                >
                                    {label}
                                </StepLabel>
                            </Step>
                        )   
                    })
                }
            </Stepper> 
            : <React.Fragment>
                <Step key={"indexing"}
                        completed={false}>
                    <StepLabel
                        StepIconComponent={CustomStepIcon}
                        sx={{ fontSize: '12px', '& .MuiStepLabel-label': { fontSize: '0.8rem' } }}
                    >
                        Indexing Article ...
                    </StepLabel>
                </Step>
            </React.Fragment>
            }
        </Box>
    );
};

StepperComponent.propTypes = {
    activeStep: PropTypes.number.isRequired,
    steps: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export default StepperComponent;
